import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=348b6bd0&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "@/assets/thankYou/css2.css?vue&type=style&index=0&id=348b6bd0&prod&scoped=true&lang=css&external"
import style1 from "@/assets/thankYou/style.css?vue&type=style&index=1&id=348b6bd0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b6bd0",
  null
  
)

export default component.exports